import React from 'react';
import classNames from 'classnames';

const PRELOAD_COUNT = 3;

export class Gallery extends React.Component {
	state = {
		pageIndex: 0,
	}

	render() {
		const { base, images, name } = this.props;
		const { pageIndex } = this.state;
		const preloadImages = images.slice(pageIndex, pageIndex + PRELOAD_COUNT);
		const next = () => this.setState({ pageIndex: Math.min(pageIndex + 1, images.length - 1) });
		const prev = () => this.setState({ pageIndex: Math.max(0, pageIndex - 1) });
		return (
			<div className="draft-gallery-slider">
				{preloadImages.map((url, offset) => (
					<img
						onClick={next}
						key={pageIndex + offset}
						src={base + url}
						style={{
							display: offset === 0 ? 'block' : 'none'
						}}
					/>
				))}
				<div className={classNames("prev-image", { disabled: pageIndex <= 0 })} onClick={prev}></div>
				<div className={classNames("next-image", { disabled: pageIndex >= images.length - 1 })} onClick={next}></div>
			</div>
		)
	}
}



// WEBPACK FOOTER //
// ./lib/components/Gallery.jsx